import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3.5 py-1.5 text-xs sm:text-sm font-medium bg-white text-brand-text border border-brand-dark/15 rounded-md transition-colors hover:bg-brand-dark hover:text-white hover:border-brand-dark disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
